import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-download\"><defs><style>#icon-download .a{fill:#fff;}#icon-download .b{fill:none;}</style></defs><g transform=\"translate(-440 -332)\"><path class=\"a\" d=\"M160.1,74.014h-3.882V68.191h-5.823v5.823H146.51l6.793,6.793ZM146.51,82.748v1.941H160.1V82.748Z\" transform=\"translate(297.172 265.06)\" /><rect class=\"b\" width=\"20\" height=\"20\" transform=\"translate(440 332)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol